import Api from "../config/Api";
import { BackendApiInstance } from "../config/Interceptor";
export function vehicleBidList(id) {
  return BackendApiInstance.get(`${Api.vehicleBidList}?idVehicle=${id}`);
}
